import { render } from "./FeedbackCard.vue?vue&type=template&id=270d688d&scoped=true"
import script from "./FeedbackCard.vue?vue&type=script&lang=js"
export * from "./FeedbackCard.vue?vue&type=script&lang=js"

import "./FeedbackCard.vue?vue&type=style&index=0&id=270d688d&scoped=true&lang=css"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-270d688d"]])

export default __exports__